import cx from 'classnames';
import Link from 'next/link';

import ShareTermButton from '../ShareTermButton';
import { GlossaryPageGlossaryTermFragment } from '../query.generated';
import styles from './index.module.scss';

const TermListItem = ({
  glossaryTerm,
  className,
}: {
  glossaryTerm: GlossaryPageGlossaryTermFragment;
  className?: string;
}) => {
  const glossaryTermPageUrl = `/glossary/${glossaryTerm.slug}`;

  return (
    <article id={glossaryTerm.slug ?? undefined} className={cx(styles.content, className)}>
      <Link className={styles.cardLink} tabIndex={-1} href={glossaryTermPageUrl} aria-hidden />

      <h2 className={styles.name}>
        {glossaryTerm.name}
        <ShareTermButton className={styles.shareButton} glossaryTerm={glossaryTerm} />
      </h2>

      <p className={styles.summary}>{glossaryTerm.summary}</p>

      <Link className={styles.ctaLink} href={glossaryTermPageUrl} aria-label={`Learn more about ${glossaryTerm.name}`}>
        Learn more
      </Link>
    </article>
  );
};

export default TermListItem;
